import { OperationAlert } from "../../../types/alert/operation-alert";
import { OperationAlertDto } from "../../../types/alert/operation-alert-dto";
import { convertOperationAlertDeliveryGroup } from "./operation-alert-delivery-group-converter copy";

export const convertOperationAlert = (
  operationAlertDto: OperationAlertDto
): OperationAlert => {
  return {
    schedulesNotStarted: operationAlertDto.schedulesNotStarted.map((alert) =>
      convertOperationAlertDeliveryGroup(alert)
    ),
    deliveryGroupsCompletedWithoutImage:
      operationAlertDto.deliveryGroupsCompletedWithoutImage.map((alert) =>
        convertOperationAlertDeliveryGroup(alert)
      ),
    deliveryGroupsCompletedWithDelay:
      operationAlertDto.deliveryGroupsCompletedWithDelay.map((alert) =>
        convertOperationAlertDeliveryGroup(alert)
      ),
    deliveryGroupsExpectedToBeDelayed:
      operationAlertDto.deliveryGroupsExpectedToBeDelayed.map((alert) =>
        convertOperationAlertDeliveryGroup(alert)
      ),
  };
};
